<template>
  <div class="passwordBox animated fadeInDown">
    <div class="row">
      <div class="col-md-12">
        <div class="ibox-content">
          <h1 class="font-bold text-center">Reset password</h1>

          <div class="row" style="padding-top:30px;">
            <div class="col-lg-12">
              <el-form
                :model="detail"
                ref="detail"
                label-width="0px"
                class="demo-dynamic form-horizontal detailPage"
              >
                <div class="form-group">
                  <label class="col-sm-4 control-label">
                    New Password
                  </label>
                  <div class="col-sm-8">
                    <el-form-item
                      prop="password"
                      :rules="[{
                        required: true,
                        message: $t('message.required'),
                        trigger: 'blur'
                      },{ 
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/, 
                        message: 'Please enter a password in the correct format',
                        trigger: 'blur'
                      }]"
                    >
                      <el-input
                        type="password"
                        v-model.trim="detail.password"
                        autocomplete="off"
                        show-password
                        :name="'password'"
                      />
                      <div class="passwordFormat">{{ $t("message.passwordFormat") }}</div>
                    </el-form-item>

                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-4 control-label">
                    Confirm New Password
                  </label>
                  <div class="col-sm-8">
                    <el-form-item
                      prop="confirmPassword"
                      :rules="[{ 
                        validator: validatePass, 
                        trigger: 'blur' 
                      }]"
                    >
                      <el-input
                        type="password"
                        v-model.trim="detail.confirmPassword"
                        autocomplete="off"
                        show-password
                        :name="'confirmPassword'"
                      />
                    </el-form-item>

                  </div>
                </div>
                <div class="text-center">
                  <el-button
                    type="primary"
                    @click="checkEvent"
                  >Reset</el-button>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
import config from "../config";
import sha256 from 'sha256'
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detail:{
        password: "",
        confirmPassword: "",
      },
      randomCode: ""
    };
  },
  created() {
    this.randomCode = this.$route.query.code;
    this.validatePass = (rule, value, callback) => {
        if (value != this.detail.password) {
          callback(new Error('Passwords do not match!'));
        } else {
          callback();
        }
      };
  },
  mounted() {
    let that = this;
  },
  methods: {
    checkEvent: function() {
      this.$refs["detail"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    async submit() {
      var objdata = {};
      objdata.password = sha256(this.detail.password);
      objdata.passwords = sha256(this.detail.confirmPassword);
      objdata.randomCode = this.randomCode;
      objdata.apiUrl = this.apiConfig.accountResetPassword;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.$router.push({ path: "/" });
    }
  }
};
</script>